import React from 'react';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="bg-chocolate-900 text-chocolate-50/60 py-12 px-4 text-center border-t border-chocolate-800" data-id="element-80">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-81">
        <p className="font-heading text-2xl text-gold-400 font-bold uppercase" data-id="element-82">
          MÉTODO ANTÍDOTO DULCE
        </p>

        <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-83">
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-84">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-85">
            Políticas de Privacidad
          </a>
          <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-86">
            Contacto
          </a>
        </div>

        <p className="text-xs mt-8" data-id="element-87">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>

        <p className="text-sm" data-id="element-88">
          &copy; {year} Método Antídoto Dulce. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}